export const sumIncomeAmounts = (incomes: { amount: number }[]) =>
	incomes.reduce((acc, curr) => acc + curr.amount, 0);
